/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import "../ListCards.css";
import PropTypes from "prop-types";

const ListCardsCardItem = (props) => {
  if (!props.data.card) return null;

  let cardClassName = null;
  let cardLogoClassName = null;
  const languageObj = props.languageObj;
  //  const color = props.color; // color.headerColor , color.buttonColor

  switch (props.data.card.brand) {
    case "visa":
      cardClassName = "ListCards-visa";
      cardLogoClassName = "ListCards-visaLogo";
      break;
    case "amex":
      cardClassName = "ListCards-amex";
      cardLogoClassName = "ListCards-amexLogo";
      break;
    case "mastercard":
      cardClassName = "ListCards-mastercard";
      cardLogoClassName = "ListCards-mastercardLogo";
      break;
    case "unionpay":
      cardClassName = "ListCards-unionpay";
      cardLogoClassName = "ListCards-unionpayLogo";
      break;
    default:
      return null;
  }

  return (
    <div className={cardClassName}>
      <div
        className="ListCards-deleteCard"
        onClick={() =>
          props.onDeleteCard &&
          props.onDeleteCard(props.data.id, props.data.card.last4)
        }
      >
        <div className="ListCards-removeIcn" />
      </div>
      <div className="ListCards-cardNumber">
        *&nbsp;*&nbsp;*&nbsp;*&nbsp; &nbsp; *&nbsp;*&nbsp;*&nbsp;*&nbsp; &nbsp;
        *&nbsp;*&nbsp;*&nbsp;*&nbsp; &nbsp; {props.data.card.last4}
      </div>
      <div className={cardLogoClassName}></div>
      <div className="ListCards-valid">
        {languageObj.expiry}

        <div className="ListCards-expiry">
          <div className="ListCards-expiryDate">
            {props.data.card.exp_month}
          </div>
          <div className="ListCards-slash">/</div>
          <div className="ListCards-expiryYear">{props.data.card.exp_year}</div>
        </div>
      </div>
    </div>
  );
};

ListCardsCardItem.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
  isAuth: PropTypes.bool,
  data: PropTypes.object,
  color: PropTypes.object,
  onDeleteCard: PropTypes.func,
};

export default ListCardsCardItem;
